import { RouteObject } from "src/router";
import { prepareRoutes } from "src/components/spaces/prepare-routes";
import { setRoutes } from "src/components/spaces/path-access-registry";
import { routes as eventRoutes } from "src/events";
import { routes as monitoringRoutes } from "src/pages/alerting";
import { routes as analyticsRoutes } from "src/pages/analytics/routes";
import { routes as audienceRoutes } from "src/pages/audiences/routes";
import { routes as dashboardsRoutes } from "src/pages/dashboards/routes";
import { routes as destinationRoutes } from "src/pages/destinations";
import { routes as experimentsRoutes } from "src/pages/experiments/routes";
import { routes as homeRoutes } from "src/pages/home";
import { routes as overviewRoutes } from "src/pages/overview";
import { routes as identityResolutionRoutes } from "src/pages/identity-resolution";
import { routes as journeyRoutes } from "src/pages/journeys/routes";
import { routes as modelRoutes } from "src/pages/models";
import { routes as profileRoutes } from "src/pages/profiles/routes";
import { routes as schemaRoutes } from "src/pages/schema/routes";
import { routes as sourceRoutes } from "src/pages/sources";
import { routes as syncRoutes } from "src/pages/syncs";
import { routes as traitRoutes } from "src/pages/traits";
import { routes as agentsRoutes } from "src/pages/agents/routes";
import { routes as campaignRoutes } from "src/pages/campaigns/routes";
import { routes as lifecycleStudioRoutes } from "src/pages/lifecycle-studio/routes";
import { routes as connectionRoutes } from "src/pages/connections/routes";
import { routes as cmsRoutes } from "src/pages/cms/routes";
import { routes as adStudioRoutes } from "src/pages/ad-studio/routes";
import { routes as contextHubRoutes } from "src/pages/context-hub/routes";
import { routes as sequenceRoutes } from "src/pages/sequences";
import { routes as extensionRoutes } from "src/pages/extensions";
import { routes as settingsRoutes } from "src/pages/settings";
import { routes as metricsRoutes } from "src/pages/metrics";
import { routes as priorityListRoutes } from "src/pages/priority-lists";
import { routes as organizationRoutes } from "src/pages/organizations";
import { routes as decisionEngineRoutes } from "src/pages/decision-engines";
import { routes as governanceRoutes } from "src/pages/governance";
import { routes as templateRoutes } from "src/pages/templates";
import { routes as adminToolsRoutes } from "src/pages/admin-tools/routes";
import { routes as lineageInternalRoutes } from "src/pages/lineage";
import { routes as miscRoutes } from "src/pages/misc";
import { routes as setupRoutes } from "src/pages/setup";
import { routes as cepAssetsRoutes } from "src/cep/assets/routes";
import { routes as cepCampaignRoutes } from "src/cep/campaigns/routes";
import { routes as cepMessageRoutes } from "src/cep/messages/routes";
import { routes as cepDeliverabilityRoutes } from "src/cep/deliverability/routes";
import { routes as cepReportingRoutes } from "src/cep/reporting/routes";
import { routes as cepSettingsRoutes } from "src/cep/settings/routes";
import { CepLayout } from "src/cep/cep-layout";

// Eagerly preload the home chunk — it's the most common landing page.
// This fires the dynamic import immediately so the chunk downloads in parallel
// with the main bundle instead of waiting for React to render the route.
import("src/pages/home/home").catch(() => {});

/**
 * Raw workspace routes with spacesAccess declarations.
 */
const rawJsonSlugRoutes: RouteObject[] = [
  ...homeRoutes,
  ...overviewRoutes,
  ...monitoringRoutes,
  ...modelRoutes,
  ...sourceRoutes,
  ...destinationRoutes,
  ...syncRoutes,
  ...audienceRoutes,
  ...analyticsRoutes,
  ...schemaRoutes,
  ...identityResolutionRoutes,
  ...journeyRoutes,
  ...eventRoutes,
  ...traitRoutes,
  ...agentsRoutes,
  ...dashboardsRoutes,
  ...campaignRoutes,
  ...lifecycleStudioRoutes,
  ...connectionRoutes,
  ...profileRoutes,
  ...cmsRoutes,
  ...adStudioRoutes,
  ...contextHubRoutes,
  ...experimentsRoutes,
  ...sequenceRoutes,
  ...extensionRoutes,
  ...settingsRoutes,
  ...metricsRoutes,
  ...priorityListRoutes,
  ...organizationRoutes,
  ...decisionEngineRoutes,
  ...governanceRoutes,
  ...templateRoutes,
  ...lineageInternalRoutes,
  ...miscRoutes,
  ...adminToolsRoutes,
  {
    element: <CepLayout />,
    spacesAccess: "hidden-from-limited-view",
    children: [
      ...cepAssetsRoutes,
      ...cepCampaignRoutes,
      ...cepDeliverabilityRoutes,
      ...cepReportingRoutes,
      ...cepMessageRoutes,
      ...cepSettingsRoutes,
    ],
  },
  ...setupRoutes,
];

/**
 * Processed routes ready for the router.
 * prepareRoutes attaches spacesAccess to route handles for runtime access.
 */
export const jsonSlugRoutes = prepareRoutes(rawJsonSlugRoutes);

// Populate the path access registry used by SpaceProvider for route-level
// access control. This runs at module load time, before SpaceProvider renders.
setRoutes(jsonSlugRoutes);
